import { useQuery } from "react-query"
import { getCustomersById } from "api/Customers";


export const useCustomerById = (id: any) => {

    return useQuery<Array<any> | any>(
        ['dashboardCustomers', id],
        () => getCustomersById({ costumer_id: id }),
        {
            enabled: !!id,
            onError(error: any) {
                console.error(error)
            }
        }
    )
}